import Vue from "vue"

export const triggerevents = {
  namespaced: true,

  state: {
    UploadTrigger: 1,
    AppointmentTrigger: 1,
    previewTrigger: 1,
    newTrigger: 1,
    previewCloseTrigger: 1,
    newDialogTrigger: 1,
    newAccountDialogTrigger: 1,
    globalSnackbarTrigger: 1,
    activeSnackbars: [],
  },

  mutations: {
    INCREMENT_UPLOAD_TRIGGER(state) {
      state.UploadTrigger++;
    },

    INCREMENT_APPOINTMENT_TRIGGER(state) {
      state.AppointmentTrigger++;
    },

    SHOW_GLOBAL_SNACKBAR(state, payload) {
      var newsnackbar = Object.assign({}, {
        id: state.globalSnackbarTrigger,
        currentTime: 0,
        progress: 100,
        code: payload && payload.code ? payload.code : undefined,
        text: payload && payload.text ? payload.text : 'Unknown error occurred',
        subtext: payload && payload.subtext ? payload.subtext : undefined,
        color: payload && payload.color ? payload.color : 'error',
        timeout: payload && payload.timeout ? payload.timeout : 9000,
        icon: payload && payload.icon ? payload.icon : 'mdi-alert',
        errorlogg: payload.errorlogg,
      });
      var index = state.activeSnackbars.findIndex(x => x.text == newsnackbar.text)
      if (index > -1) {

        state.activeSnackbars.splice(index, 1);
        setTimeout(() => {
          state.globalSnackbarTrigger++;
          state.activeSnackbars.push(newsnackbar);
        }, 100);
      }
      else {

        state.globalSnackbarTrigger++;
        state.activeSnackbars.push(newsnackbar);
      }

    },

    SET_SNACKBAR_PROGRESS(state, update) {
      var index = state.activeSnackbars.findIndex(x => x.id === update.id);
      if (index > -1) {
        var snackbar = state.activeSnackbars[index];
        var newsnackbar = Object.assign({}, snackbar)
        newsnackbar.progress = update.progress;
        Vue.set(state.activeSnackbars, index, newsnackbar);
      }
    },

    ClOSE_SNACKBAR(state, id) {
      state.activeSnackbars = state.activeSnackbars.filter(function (x) {
        return x.id != id;
      });
    },
  },

  actions: {
    triggerUpload({ commit }) {
      commit("INCREMENT_UPLOAD_TRIGGER");
    },

    triggerAppointment({ commit }) {
      commit("INCREMENT_APPOINTMENT_TRIGGER");
    },

    showGlobalSnackbar({ commit }, snackbarproperties) {
      commit("SHOW_GLOBAL_SNACKBAR", snackbarproperties);
    },

    responseSnackbar({ dispatch }, event) {
      const response = event.response;
      const method = event.method;
      const input = event.input;
      const route = window.location.href;
      const text = event.text;
      const color = event.color;
      const timeout = event.timeout;
      const icon = event.icon;

      var code = response && response.status ? response.status : undefined;
      var errortext;
      var subtext = event?.subtext;

      if (text) {
        if (text.indexOf(".") < text.length - 2) {
          subtext = text.substring(text.indexOf(".") + 1);
          errortext = text.substring(0, text.indexOf("."));
        }
        else {
          errortext = text;
          subtext = response ? response.data : null;
        }
      } else if (response && response.data) {
        if (response.status === 500) {
          errortext = "Internal server error";
          if (response.data.Message) {
            errortext = response.data.Message;
          }
          subtext = response.config.url;
        }
        else {
          errortext = response.data;
          subtext = response.config.url;
        }
      } else if (method) {
        errortext = 'Exception in ' + method;
      } else {
        errortext = undefined;
      }

      code = event.noClutter ? null : subtext;

      dispatch('showGlobalSnackbar', {
        code: code,
        text: errortext,
        subtext: subtext,
        color: color,
        timeout: timeout,
        icon: icon,
        errorlogg: {
          Route: route,
          Method: method,
          Input: input,
          Response: {
            Code: event.noClutter == true ? null : (response.status ?? undefined),
            Data: (response.data ?? undefined)
          }
        }
      })

      if (response) {
        if (response.status > 399) {
          throw response && response.data;
        }
      }
    },

    simpleCreateSuccess({ dispatch }, text) {
      var outtext = text ? text : 'fallback';
      dispatch('showGlobalSnackbar', { code: undefined, text: outtext, subtext: undefined, color: 'quaternary', timeout: 5000, icon: 'mdi-check' })
    },

    simpleChangeSuccess({ dispatch }, text) {

      /*Can be used like so:

      store.dispatch('triggerevents/simpleChangeSuccess', "Something changed :)");

      OR

      store.dispatch('triggerevents/simpleChangeSuccess', {title: 'Feature unavailable', subtitle:"We are working on this. Your patience is appriciated :)", icon: "square_foot" });

      */

      var outtext = 'fallback';
      var outsubtext = null;
      var outicon = 'mdi-check'
      if (typeof text === 'string' || text instanceof String) {
        outtext = text;
      }
      else if (typeof text === 'object' && !Array.isArray(text)) {
        text.title ? outtext = text.title : null;
        text.subtitle ? outsubtext = text.subtitle : null;
        text.icon ? outicon = text.icon : null;
      }
      dispatch('showGlobalSnackbar', { code: undefined, text: outtext, subtext: outsubtext, color: 'primary', timeout: 3000, icon: outicon })
    },

    simpleDeleteSuccess({ dispatch }, text) {
      var outtext = text ? text : 'fallback';
      dispatch('showGlobalSnackbar', { code: undefined, text: outtext, subtext: undefined, color: 'primary', timeout: 5000, icon: 'mdi-delete-empty' })
    },

    setSnackbarProgress({ commit }, update) {
      commit("SET_SNACKBAR_PROGRESS", update);
    },

    closeSnackbar({ commit }, id) {
      commit("ClOSE_SNACKBAR", id);
    },
  },

  getters: {
    UploadTrigger: state => {
      return state.UploadTrigger;
    },
    AppointmentTrigger: state => {
      return state.AppointmentTrigger;
    },
    GlobalSnackBarTrigger: state => {
      return state.globalSnackbarTrigger;
    },
    ActiveSnackbars: state => {
      return state.activeSnackbars;
    },
  },
};
